const educationElements = [
    {
      id: 1,
      title: "University of North Carolina at Chapel Hill",
      location: "Chapel Hill, North Carolina",
      description: ["Computer Science & Business Administration(Real Estate)  - Current Junior ", "Clubs: Business Technology Club, First Generations Investors Club, Spikeball Club, Competitive Programming Club, Video-Game Development Club", "President and Co-Founder of Iota Nu Delta (Multicultural Fraternity)", "Presidential Medal for Volunteering"],
      date: "2022-2026",
      icon: "school",
      color: "blue",
    },
    {
      id: 2,
      title: "Panther Creek High School",
      location: "Cary, North Carolina",
      description: ["HS Rank: 7/800     |     ACT: 34", "President of American Enterprise System Committee for FBLA: National Finalist 2021 & achieved 1st at state-wide competition three years in a row", "Varisty Soccer (Captain)"],
      date: "2018-2022",
      icon: "school",
      color: "blue",
    },
  ];
  
  export default educationElements;